module.exports = __webpack_public_path__ + "static/media/sparkle.819b3fe7.mov";